var $ = require('jquery');
var _ = require('underscore');
var Marionette = require('marionette');
var Backgrid = require('backgrid');
var Behaviors = require('Behaviors');
var consultation = require('Consultation');
var Dialog = require('Dialog');
var Entities = require('Entities');
var Export = require('HomeExport');
var Filters = require('HomeFilters');
var Grid = require('Grid');
var Quicklinks = require('HomeQuicklinks');
var GclQuicklinks = require('HomeGclQuicklink');
var NpoQuicklink = require('HomeNpoQuicklink');
var Pagination = require('Pagination');
var PredefinedFilters = require('HomePredefinedFilters');
var Router = require('Router');
var Search = require('HomeSearch');
var Configuration = EY.Consultation.Lookups.Configuration;
var FilterType = EY.Consultation.Lookups.FilterType;
var Labels = EY.Consultation.Labels;
var Lookups = EY.Consultation.Lookups;
var Resources = EY.Consultation.Resources;
var StatusType = EY.Consultation.Lookups.StatusType;
var User = EY.Consultation.CurrentUser;

var AttachmentSearch = Marionette.View.extend({
    template:'#attachmentSearch',
    ui:{
        file:'#file',
        separator:'#separator'
    },
    onAttach:function(){
        _.any(this.options.record.get('attachmentResult'),{id:this.model.get('id')})
         && this.ui.file.addClass('mark');
         this.ui.file.prop('href', window.encodeURI(this.model.urlRoot + '/' + this.model.id + '?zone=' + this.model.get('zone') + '&name=' + this.model.get('filename').replace('#', ' ') + '&token=' + Lookups.Azure.Token));
         this.model.collection.last().get('id') === this.model.get('id') && this.ui.separator.hide();
    }
});
var AttachmentSearchCollection = Marionette.CollectionView.extend({
    childView:AttachmentSearch,
    childViewOptions: function () {
        var options = _.clone(this.options);
        return options;
    },
});

var AttachmentResultLayout = Marionette.View.extend({
    template:'#attachmentResultLayout',
    regions:{
        matchedAttachments:'#matchedAttachments'
    },
    ui:{
        id:'#id',
        recordType:'#recordType'  
    },
    events:{
        'click @ui.id':function(){
            Router.navigate((!/CountryRecord/.test(this.model.get('link')) ? 'Record/' : 'CountryRecord' + this.model.get('countryId')) + this.model.id, { trigger: true });
            this.triggerMethod('close:dialog');
        }
    },
    onAttach:function(){
        this.ui.recordType.text(this.model.get('recordTypeId'));
        this.ui.id.html(this.model.get('shortId'));
        var attachmentResultCollection = new AttachmentSearchCollection({
            collection:this.options.collection,
            record:this.model
        }) 
        this.getRegion('matchedAttachments').show(attachmentResultCollection);
    }
});


var AttachmentResultCell = Backgrid.UriCell.extend({
    render: function () {
        Backgrid.UriCell.prototype.render.apply(this, arguments);
        this.$el.empty();
        var model = this.model;
        var attachments = model.get('attachments');
        var attachmentLink = $('<a class="cursorPointer"><i class="fa fa-paperclip"></i></a>');
        this.$el.addClass('text-center visible-lg visible-md');
        if(attachments && attachments.length > 0) {
            this.$el.append(attachmentLink.click(function(){
                Dialog.show({
                    cancelLabel: Labels.Close,
                    headerLabel: 'Attachments',                    
                    view: new AttachmentResultLayout({
                        collection:new Entities.Attachments(attachments),
                        model:model
                    })
                })
            }));
        }
        if (model.get('attachmentResult') && model.get('attachmentResult').length > 0 && $('#keyword').val().trim().toLowerCase()) {
            this.$el.addClass('mark');
        }else{
            this.$el.removeClass('mark');
        }
        return this;
    }
});

var largeHeaderCell = Backgrid.HeaderCell.extend({
    render: function () {
        Backgrid.HeaderCell.prototype.render.apply(this, arguments);
        this.$el.addClass('visible-lg visible-md');
        return this
    }
});

var mediumHeaderCell = Backgrid.HeaderCell.extend({
    render: function () {
        Backgrid.HeaderCell.prototype.render.apply(this, arguments);
        this.$el.addClass('visible-lg visible-md visible-sm');
        return this
    }
});

var stringCell = Backgrid.StringCell.extend({
    render: function () {
        Backgrid.StringCell.prototype.render.apply(this, arguments);
        this.$el.addClass('visible-lg visible-md');
        return this
    }
});

var approverGroups = function (role) {
    var roleIds = _.pluck(_.where(User.roles, { roleId: role }), 'roleId');
    return _.chain(Resources.ApproverGroup).filter(function (approverGroup) {
        return _.indexOf(roleIds, approverGroup.roleId) > -1;
    }).pluck('id').value();
};

var ActiveFilter = {
    $nor: [{ statusTypeId: StatusType.Complete }, { statusTypeId: StatusType.Draft }]
};

var DateFilter = {
    $or: [{ createdOn: { $lt: new Date(new Date().setDate(new Date().getDate() - 305)) } },
    { $and: [{ approvalBy: { $ne: '' } }, { approvalBy: { $lt: new Date(new Date().setDate(new Date().getDate() - 45)) } }] }]
};

var EligiblilityFilter = {
    $or: [{ completedOn: { $gte: new Date(new Date().setDate(new Date().getDate() - 30)) } },
    { statusTypeId: { $ne: StatusType.Complete } }]
};

var Filter = {
    $or: [{ $and: [{ createdBy: User.upn }, EligiblilityFilter] },
    {
        'approvers.upn': User.upn, statusTypeId: { $ne: StatusType.Draft }, completedOn: { $lt: new Date(new Date().setDate(new Date().getDate() - 30)) },
        $nor: [{ createdBy: User.upn },
        { approvers: { $elemMatch: { approverGroupId: "PartnerInCharge", upn: User.upn } } },
        { approvers: { $elemMatch: { approverGroupId: "EngagementQualityReviewer", upn: User.upn } } },
        { approvers: { $elemMatch: { approverGroupId: "TeamMember", upn: User.upn } } },
        { approvers: { $elemMatch: { approverGroupId: "AdvanceApprover", upn: User.upn } } },
        { approvers: { $elemMatch: { approverGroupId: "RequiredNotification", upn: User.upn } } }]
    },
    { $and: [{ 'approvers.upn': User.upn }, { statusTypeId: { $ne: StatusType.Draft } }, EligiblilityFilter] },
    { assignedTo: User.upn, statusTypeId: StatusType.Preparation }]
};
var FilterCompletedAndAll = {
    $or: [{ $and: [{ createdBy: User.upn }, EligiblilityFilter] },
    {
        'approvers.upn': User.upn, statusTypeId: { $ne: StatusType.Draft }, completedOn: { $gt: new Date(new Date().setDate(new Date().getDate() - 30)) },
        $nor: [{ createdBy: User.upn },
        { approvers: { $elemMatch: { approverGroupId: "PartnerInCharge", upn: User.upn } } },
        { approvers: { $elemMatch: { approverGroupId: "EngagementQualityReviewer", upn: User.upn } } },
        { approvers: { $elemMatch: { approverGroupId: "TeamMember", upn: User.upn } } },
        { approvers: { $elemMatch: { approverGroupId: "AdvanceApprover", upn: User.upn } } },
        { approvers: { $elemMatch: { approverGroupId: "RequiredNotification", upn: User.upn } } }]
    },
    { $and: [{ 'approvers.upn': User.upn }, { statusTypeId: { $ne: StatusType.Draft } }, EligiblilityFilter] },
    { assignedTo: User.upn, statusTypeId: StatusType.Preparation }]
};
var FilterPending = {
    $or: [{ assignedTo: User.upn },
    {
        $and: [
            // Show if 
            // 1. RecordType is 'RequiredNotification' and
            // 2. StatusType is 'UsersNotified' and
            // 3. you're listed in any approver field under ToBeNotified section
            { recordTypeId: "RecordType_RequiredNotification" },
            { 
                statusTypeId: { $eq: StatusType.UsersNotified },
                approvers: { $elemMatch: 
                    { 
                        approverGroupId: { $regex: 'EngagementQualityReviewer|SubCountryProfessionalPractice|CountryProfessionalPractice|RegionalProfessionalPractice|RequiredNotification' }, 
                        upn: User.upn, 
                        approvalNotRequired: true, 
                        acknowledgeStatus: '', 
                        acknowledgeDate: '' 
                    } 
                } 
            },
        ]
    }]
};
var GeographyFilter = {
    $or: [{ statusTypeId: { $ne: StatusType.Draft }, geographyId: { $regex: User.geographyByRole['CountryProfessionalPractice'] + '|' + User.geographyByRole['Reviewer'] + '|' + User.geographyByRole['UsRegionReviewer'] }, restricted: false },
    { geographyId: { $regex: User.geographyByRole['CountryAdministrator'] } },
    { geographyTypePath: '/Area/Region/Country/SubCountry/', geographyId: { $regex: User.geographyByRole['RegionAdministrator'] } },
    { statusTypeId: { $ne: StatusType.Draft }, geographyTypePath: '/Area/Region/Country/SubCountry/', geographyId: { $regex: User.geographyByRole['RegionalProfessionalPractice'] }, restricted: false }]
};

var RoleFilter = {
    $and: [{
        $or: [{ statusTypeId: StatusType.Preparation, geographyId: { $regex: User.geographyByRole['CountryProfessionalPractice'] + '|' + User.geographyByRole['Reviewer'] } },
        { approverGroupId: { $in: approverGroups('CountryProfessionalPractice') } },
        { geographyTypePath: '/Area/Region/Country/SubCountry/', approverGroupId: { $in: approverGroups('RegionalProfessionalPractice') } }]
    }, { restricted: false }]
};

var Select = { assignedToGivenName: 1, attachments:1, approvalBy: 1, clientName: 1,createdOn: 1, creatorFullName: 1, countryId: 1, engagementName: 1, link: 1, partner: 1, recordTypeId: 1, statusResourceKey: 1, statusTypeId: 1, subjectId: 1, subject: 1, subtypeId: 1, subtype: 1, typeId: 1, type: 1 };

var Action = Marionette.View.extend({
    className: 'string-cell sortable renderable id',
    events: {
        'click @ui.id': 'navigate'
    },
    tagName: 'td',
    template: '#homeGridAction',
    ui: {
        id: '#id'
    },
    navigate: function () {
        if (EY.Consultation.Lookups.Configuration.OpenRecordInNewTab) {
            window.open(window.location.origin + '/#Record/' + this.model.id);
        } else {
            //Router.navigate((this.model.get('link').replace(window.location.origin + '/#', '') + '/').replace('//', '/') + this.model.id, { trigger: true });
            Router.navigate((!/CountryRecord/.test(this.model.get('link')) ? 'Record/' : 'CountryRecord' + this.model.get('countryId')) + this.model.id, { trigger: true });
        }
    },
    onRender:function(){
        this.ui.id.html(this.model.get('shortId'));
    }
});
    
var Tooltip = Marionette.View.extend({
    behaviors: [Behaviors.TooltipGrid],
    className: 'string-cell sortable renderable visible-lg visible-md visible-sm tooltip-css',
    tagName: 'td',
    template: _.noop
});


var MediumCell = Marionette.View.extend({
    behaviors: [Behaviors.TooltipGrid],
    className: 'string-cell sortable renderable visible-lg visible-md tooltip-css',
    tagName: 'td',
    template: _.noop
});

//var RecordType = Marionette.View.extend({
//    behaviors: [Behaviors.TooltipGrid],
//    className: 'string-cell sortable renderable visible-lg visible-md visible-sm visible-xs record-type tooltip-css',
//    tagName: 'td',
//    template: _.noop
//});

var columns = function () {
    var gridColumns = [{ name: 'id', label: Labels.RecordID, editable: false, cell: Action },
    { name: 'approvalBy', label: Labels.ApproveBy, editable: false, cell: stringCell,headerCell:largeHeaderCell },
    { name: 'statusTypeId', label: Labels.Status, editable: false, cell: 'string' },
    { name: 'assignedToGivenName', label: Labels.AssignedTo, editable: false, cell: stringCell,headerCell:largeHeaderCell },
    { name: 'clientName', label: Labels.ClientName, editable: false, cell: 'string' },
    { name: 'engagementName', label: Labels.EngagementName, editable: false, cell: MediumCell,headerCell:largeHeaderCell },
    { name: 'partner', label: Labels.PartnerInCharge, editable: false, cell: stringCell,headerCell:largeHeaderCell },
    { name: 'type', label: Labels.Topic, editable: false, cell: Tooltip,headerCell:mediumHeaderCell },
    { name: 'subtype', label: Labels.Subtopic1, editable: false, cell: Tooltip,headerCell:mediumHeaderCell },
    { name: 'recordTypeId', label: Labels.RecordType, editable: false, cell: 'string' }];
    if(!EY.Consultation.Lookups.IsHandHeldDevice){
        gridColumns.push({ name: 'attachmentResult', label:'', editable: false, cell: AttachmentResultCell,headerCell:largeHeaderCell });
    }
    return gridColumns;
};

var format = function (records) {
    records.on('synced', function () {
        var matchingAttachmentIds = sessionStorage.getItem('matchedAttachmentIds')&& sessionStorage.getItem('matchedAttachmentIds').split(',');
        records.each(function (record) {
            var attachmentResult = _.filter(record.get('attachments'), function (attachment) {
                return _.any(matchingAttachmentIds, function (id) {
                    return id === attachment.id
                });
            });
            record.set({
                approvalBy: record.get('approvalBy') ? new Date(record.get('approvalBy')).format() : '',
                recordTypeId: Labels[record.get('recordTypeId')],
                statusTypeId: Labels[record.get('statusResourceKey')],
                attachmentResult: attachmentResult
            });
        });

        // search hightlight
        if ($('#quicklinks,#predefinedFilters').find('.link-active').length == 0 && $('#keyword').val().trim().length > 0) {
            $('#homegrid').find('table td:not(.approvalBy,.statusTypeId)').each(function () {
                var keyword = $('#keyword').val().trim().toLowerCase();
                _.each(Configuration.RestrictSearchSpecialChar.split(','), function (char) {
                    if (keyword.indexOf(char) !== -1) {
                        var charArray = keyword.split(char);
                        keyword = charArray[0].replace(/\\/g, "") ? charArray[0].replace(/\\/g, "") : charArray[1].replace(/\\/g, "");
                    }
                });
                if ($(this).text().toLowerCase().indexOf(keyword) > -1) {
                    $(this).addClass("mark");
                }
            });
        } else if ($('#quicklinks,#predefinedFilters').find('.link-active').length > 0) {
            $('#keyword').val('');
            sessionStorage.removeItem('matchedAttachmentIds');
            //delete Configuration.matchedAttachmentIds;
        }
    });
    return records;
};

var filters = function () {
    if (EY.Consultation.Lookups.IsHandHeldDevice) {
        return new Entities.Queries([         
            { id: 'PendingMyAction', text: Labels.Quicklink_PendingMyAction, filter: FilterPending, select: Select, type: FilterType.Quicklink },
            { id: 'My-All', text: Labels.Quicklink_All, filter: FilterCompletedAndAll, select: Select, type: FilterType.Quicklink },
            { id: 'Search', text: Labels.Search, filter: { $or: [Filter, GeographyFilter] }, select: Select, type: FilterType.Search },
            { id: '', text: '', select: Select }
        ]);
    } else {
        return new Entities.Queries([            
            { id: 'PendingMyAction', text: Labels.Quicklink_PendingMyAction, filter: FilterPending, select: Select, type: FilterType.Quicklink },
            { id: 'My-InProgress', text: Labels.Quicklink_InProgress, filter: _.extend({ statusTypeId: { $ne: StatusType.Complete } }, Filter), select: Select, type: FilterType.Quicklink },
            { id: 'My-Completed', text: Labels.Quicklink_Completed, filter: _.extend({ statusTypeId: StatusType.Complete }, FilterCompletedAndAll), select: Select, type: FilterType.Quicklink },
            { id: 'My-All', text: Labels.Quicklink_All, filter: FilterCompletedAndAll, select: Select, type: FilterType.Quicklink },
            { id: 'RecordsAtMyLevel', text: Labels.RecordsAtMyLevel, filter: { $and: [ActiveFilter, GeographyFilter, RoleFilter] }, select: Select, type: FilterType.Predefined },
            { id: 'ActiveRecords', text: Labels.ActiveRecords, filter: _.extend({ statusTypeId: { $ne: StatusType.Complete } }, GeographyFilter), select: Select, type: FilterType.Predefined },
            { id: 'CompletedRecords', text: Labels.CompletedRecords, filter: _.extend({ statusTypeId: StatusType.Complete }, GeographyFilter), select: Select, type: FilterType.Predefined },
            { id: 'AllRecords', text: Labels.AllRecords, filter: GeographyFilter, select: Select, type: FilterType.Predefined },
            { id: 'PotentialInactiveRecords', text: Labels.PotentialInactiveRecords, filter: { $and: [ActiveFilter, GeographyFilter, DateFilter] }, select: Select, type: FilterType.Predefined },
            { id: 'Search', text: Labels.Search, filter: { $or: [Filter, GeographyFilter] }, select: Select, type: FilterType.Search },
            { id: '', text: '', select: Select }
        ]);
    }
};

var Layout = Marionette.View.extend({
    events: {
        'click @ui.export': 'export',
        'click @ui.cmtLink': 'navigateToCmt',
        'click @ui.gclLink': 'navigateToGcl',
        'click @ui.usNtLink': 'navigateToUsNT'
    },
    behaviors: [Behaviors.MobileView, Behaviors.DisableMultipleClicks],
    regions: {
        filters: '#filters',
        grid: '#homegrid',
        pager: '#pager',
        predefinedFilters: '#predefinedFilters',
        quicklinks: '#quicklinks',
        npoPendingActions: '#npoPendingActions',
        gclPendingActions: '#gclPendingActions',
        search: '#search'
    },
    template: '#homeLayout',
    ui: {
        grid: '#homegrid',
        cmtLink: '#cmt-link',
        gclLink: '#gcl-link',
        usNtLink: '#us-nt-link',
        'export': '#export',
        create: '#create',
        dropdownToRecordCreate: '#dropdown-to-recordCreate',
    },
    'export': function () {
        Export.run({ query: this.options.queries.findWhere({ selected: true }) || options.queries.get(''), queries:this.options.queries });
    },
    navigateToCmt: function() {
        window.open(EY.Consultation.NpoWeb + '#RecordCreate', "_self");
    },
    navigateToGcl: function() {
        window.open(Configuration.GclWeb + '#RecordCreate', "_self");
    },
    navigateToUsNT: function() {
        window.open(EY.Consultation.UsNotificationTrackerLink, "_self");
    },
    onRender:function() {
        if(Configuration.GlobalMessage) {
            consultation.showToast({
                result: "danger",
                text: Configuration.GlobalMessage
            });
            Configuration.GlobalMessage = '';
        }
        
        if(Configuration.CreateNewRecordDropDown == 'true') {
            this.ui.dropdownToRecordCreate.removeClass('hidden');
        } else {
            this.ui.create.removeClass('hidden');
        }

        if(Configuration.EnableCreateNewRecordForGCL == 'true') {
            this.ui.gclLink.removeClass('disabled');
        } else {
            this.ui.gclLink.addClass('disabled');
        }

        !!EY.Consultation.UsNotificationTrackerLink && this.ui.usNtLink.removeClass('hidden');
    }
});

module.exports.start = function () {
    var consultation = require('Consultation');
    var records = format(new Entities.Records());
    var queries = filters();
    var layout = new Layout({ collection: records, queries: queries });
    var counts = queries.reject(function (query) { return (query.id === '' || query.id === 'Search'); });
    var sessionFilters = User.session && User.session.get('filters');
    var fetchCompleteCount = 0;
    queries.on('fetchComplete', function() {
        fetchCompleteCount++;
        if (fetchCompleteCount == 2) {
            $('.enable-on-load').removeClass('enable-on-load');
        }
    });
    sessionStorage.getItem('matchedAttachmentIds') && sessionStorage.removeItem('matchedAttachmentIds');
    consultation.show({ view: layout });
    Quicklinks.show({ queries: queries, rows: records, region: layout.getRegion('quicklinks') });
    if (!EY.Consultation.Lookups.IsHandHeldDevice) {
        if (Configuration.NpoLink === 'true') {
            NpoQuicklink.show({ region: layout.getRegion('npoPendingActions') });
        }
        if (Configuration.GclLink == 'true') {
            GclQuicklinks.show({ region: layout.getRegion('gclPendingActions') });
        }
        PredefinedFilters.show({ queries: queries, rows: records, region: layout.getRegion('predefinedFilters') });
        Filters.show({ queries: queries, rows: records, region: layout.getRegion('filters') });
    }
    Search.show({ queries: queries, geography: GeographyFilter, filter: Filter, rows: records, region: layout.getRegion('search') });
    Grid.show({
        collection: records,
        columns: columns(),
        region: layout.getRegion('grid')
    });
    Pagination.show({ queries: queries, rows: records, region: layout.getRegion('pager'),  defaultSort: {colName: "createdOn", direction: "descending" } });
    $.when.apply(this, counts.map(function (query) {
        
        //TODO: optimize:true flag should be removed when we decide to retire the older version of configure in Redbox.js
        return records.clone().fetch({ aggregate: [{ $match: query.get('filter') }, { $count: 'count' }], optimize: true, debugging: query.id }).done(function (items) {
            query.set('count', items.length ? _.first(items).count : 0);
        });
    })).then(function () {
        queries.trigger('fetchComplete');
        if (!(sessionFilters && sessionFilters.length)) {
            queries.get('PendingMyAction').set('selected', true);
        } else {
            var selection = _.findWhere(sessionFilters, { name: '' });
            var searchFilter = _.findWhere(sessionFilters, { type: FilterType.Search });
            if (sessionFilters.length == 1 && searchFilter) {
                queries.get(selection.id).set({ 'filter': searchFilter.filter, 'selected': true, keyword: searchFilter.value });
                $('#keyword').val(searchFilter.value);
            }
            else {
                queries.get(selection.id).set('selected', false).set('selected', true);
            }
        }
    });
};


// WEBPACK FOOTER //
// ./js/Modules/Home/Home.js